import { ProgressList } from "../model/ProgressList";

export interface PreloaderOptions {
    container: HTMLElement;
}

export class Preloader {

    public readonly element: HTMLDivElement;

    constructor(options: PreloaderOptions) {
        options = e5.object.merge({

        } as PreloaderOptions, options);

        this.element = document.createElement("div");
        this.element.className = "preloader base--gradient";
        this.element.setAttribute("data-mode", "default");
        this.element.innerHTML = `
        <div class="preloader__box preloader__box--default">
            <div class="preloader__ring"></div>
            <div class="preloader__ring"></div>
            <div class="preloader__ring"></div>
            <div class="preloader__ring"></div>
            <div class="preloader__icon e5 icon-74"></div>
        </div>
        <div class="preloader__progress"></div>
        <div class="preloader__box preloader__box--error">
            <div class="preloader__icon fal fa-exclamation-triangle"></div>
            <div class="preloader__message"></div>
        </div>
        `;

        if (options.container) {
            options.container.appendChild(this.element);
        }
    }

    public addProgressList(list: ProgressList):ProgressList {
        let p: HTMLElement = this.element.querySelector(".preloader__progress");
        p.classList.remove("e5-hidden");

        let bar = document.createElement("div");
        bar.className = "preloader__progress-bar";
        bar.innerHTML = `
            <div class="preloader__progress-label">${e5.Text.escapeHtml(list.label)}</div>
            <div class="preloader__progress-bar-track">
                <div class="preloader__progress-bar-fill"></div>
            </div>            
            <div class="preloader__progress-text"></div>`;
        p.appendChild(bar);

        let fill: HTMLElement = bar.querySelector(".preloader__progress-bar-fill");
        let text: HTMLElement = bar.querySelector(".preloader__progress-text");

        let up = () => {
            fill.style.width = (e5.Calc.clamp(list.loaded / list.total, 0, 1) * 100).toFixed(4) + "%";
            text.textContent = list.text;
        };

        // up();
        list.onChange.add(up);
        list.onAdd.add(up);
        return list;
    }

    public showError(error: string): void {
        this.element.querySelector(".preloader__message").innerHTML = error;
        this.element.setAttribute("data-mode", "error");
    }

    public async show() {
        this.element.classList.remove("e5-hidden");
        this.element.offsetWidth;

        this.element.classList.toggle("preloader--hidden", false);

        return new Promise<any>((resolve, reject) => {
            setTimeout(() => {
                resolve(true);
            }, 500);
        });
    }

    public async hide() {
        this.element.classList.toggle("preloader--hidden", true);

        return new Promise<any>((resolve, reject) => {
            setTimeout(() => {
                this.element.classList.add("e5-hidden");
                this.element.remove();
                resolve(true);
            }, 500);
        });
    }
}